// openfoam.engine.js
import { OpenFoamLexer } from './openfoam.tokens.js';
import { parserInstance } from './openfoam.parser.js';
import { diffChars } from 'diff';          // small diff lib, ~1 kB gzipped

let cachedText = '';    // last full text
let cachedTokens = [];  // tokens from last run
let cachedCst = null;   // Chevrotain CST (or AST if you reduce it)

/**
 * Lex only the changed region, then splice the token array.
 * For large files you gain a lot because you don't touch the rest.
 */
function incrementalLex(newText) {
  // If there's no cached text, just do a full lexing
  if (true || !cachedText) {
    cachedText = newText;
    cachedTokens = OpenFoamLexer.tokenize(newText).tokens;
    return cachedTokens;
  }

  const changes = diffChars(cachedText, newText);
  let newTokens = [...cachedTokens];
  let cursorOld = 0;
  let cursorNew = 0;

  changes.forEach(change => {
    if (change.added) {
      const chunkTokens = OpenFoamLexer.tokenize(change.value).tokens;
      newTokens.splice(cursorOld, 0, ...chunkTokens);
      cursorNew += change.count;
    } else if (change.removed) {
      newTokens.splice(cursorOld, change.count);
      cursorOld += change.count;
    } else {
      cursorOld += change.count;
      cursorNew += change.count;
    }
  });

  cachedText = newText;
  cachedTokens = newTokens;
  return newTokens;
}

/**
 * Parse using the updated token array without re-lexing the whole file.
 */
export function incrementalParse(newText) {
  try {
    const tokens = incrementalLex(newText);
    parserInstance.input = tokens;
    const cst = parserInstance.file();   // top-level rule name
    cachedCst = cst;
    return cst;
  } catch (error) {
    console.error("Error parsing OpenFOAM text:", error);
    // Return a minimal valid CST to avoid breaking the application
    return { type: "file", entries: [] };
  }
}

/**
 * Reset the cache, forcing a full reparse on next call
 */
export function resetParseCache() {
  cachedText = '';
  cachedTokens = [];
  cachedCst = null;
}

/**
 * Get the last parsed CST without reparsing
 */
export function getLastParsedCst() {
  return cachedCst;
}
